import { useCanUseComputerState } from '#pplx/frontend/apps/ask/hooks/computer-access-hooks/useCanUseComputer.js';
import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
import { useUserSettingsQuery } from '#pplx/frontend/apps/ask/user-settings/hooks/useUserSettingsQuery.js';
import { useIsUserLoggedIn, useIsUserLoggedInLoading } from '#pplx/frontend/auth/userHooks.js';
/**
 * Encapsulates the effective default mode that starts ask input in Computer
 * mode. The local value is the last top-level mode that successfully submitted
 * from homepage Ask input; org defaults are only the first-load fallback.
 */
export function useDefaultComputerHomepage() {
    const [lastSubmittedAskInputMode] = useLocalUserSettings('lastSubmittedAskInputMode', undefined);
    const { organizationDefaultAskInputMode, hasLoadedSettings } = useUserSettingsQuery({
        reason: 'default-computer-homepage',
    });
    const isLoggedIn = useIsUserLoggedIn();
    const isLoggedInLoading = useIsUserLoggedInLoading();
    const { canUseComputer, isLoading: computerAccessLoading } = useCanUseComputerState();
    // Sidecar and Windows do not support defaulting to Computer, so resolve immediately to Search with no loading state.
    if (import.meta.env.VITE_IS_SIDECAR_BUILD || import.meta.env.VITE_IS_PERPLEXITY_DESKTOP_BUILD) {
        return {
            effectiveDefaultAskInputMode: 'search',
            defaultAskInputModeIsComputer: false,
            defaultAskInputModeIsLoading: false,
        };
    }
    const resolvedDefaultAskInputMode = lastSubmittedAskInputMode ?? organizationDefaultAskInputMode ?? 'search';
    const defaultAskInputModeIsComputer = resolvedDefaultAskInputMode === 'computer' && canUseComputer;
    const defaultModeSettingResolved = !isLoggedInLoading &&
        (lastSubmittedAskInputMode !== undefined || !isLoggedIn || hasLoadedSettings);
    const defaultAskInputModeIsLoading = !defaultModeSettingResolved ||
        (resolvedDefaultAskInputMode !== 'search' && !canUseComputer && computerAccessLoading);
    return {
        effectiveDefaultAskInputMode: resolvedDefaultAskInputMode,
        defaultAskInputModeIsComputer,
        defaultAskInputModeIsLoading,
    };
}
//# sourceMappingURL=useDefaultComputerHomepage.js.map